import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e82eba5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-exclamation-triangle",
  style: {"font-size":"24px","font-weight":"normal","color":"#ff0000"}
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-check",
  style: {"font-size":"24px","font-weight":"normal","color":"#00ff00"}
}
const _hoisted_4 = {
  key: 0,
  class: "details"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Operation", -1))
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Date/Time", -1))
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "User", -1))
const _hoisted_10 = { class: "field" }
const _hoisted_11 = {
  key: 0,
  class: "label"
}
const _hoisted_12 = {
  key: 1,
  class: "field"
}
const _hoisted_13 = {
  key: 2,
  class: "label"
}
const _hoisted_14 = {
  key: 3,
  class: "field"
}
const _hoisted_15 = {
  key: 4,
  class: "label"
}
const _hoisted_16 = {
  key: 5,
  class: "field"
}
const _hoisted_17 = {
  key: 6,
  class: "label"
}
const _hoisted_18 = {
  key: 7,
  class: "field"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Request Details", -1))
const _hoisted_20 = { class: "field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      selection: _ctx.selectRow,
      "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectRow) = $event)),
      value: _ctx.userActivityRows,
      stripedRows: "",
      selectionMode: "single",
      scrollHeight: "420px",
      tableStyle: "min-width: 50rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "id",
          header: "ID"
        }),
        _createVNode(_component_Column, {
          field: "email",
          header: "User"
        }),
        _createVNode(_component_Column, {
          field: "operation",
          header: "Operation"
        }),
        _createVNode(_component_Column, {
          field: "dateFormatted",
          header: "Timestamp"
        }),
        _createVNode(_component_Column, {
          field: "error",
          header: "Success"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2))
              : _createCommentVNode("", true),
            (!slotProps.data.error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["selection", "value"]),
    _createElementVNode("div", null, [
      _createVNode(_component_Paginator, {
        onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextRow($event))),
        rows: _ctx.maxRows,
        totalRecords: _ctx.totalRows,
        first: _ctx.offset,
        template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
      }, null, 8, ["rows", "totalRecords", "first"])
    ]),
    (_ctx.selectRow.id != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.selectRow.operation,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectRow.operation) = $event)),
              readonly: "",
              class: "input"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.selectRow.dateFormatted,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectRow.dateFormatted) = $event)),
              readonly: "",
              class: "input"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.selectRow.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectRow.email) = $event)),
              readonly: "",
              class: "input"
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.selectRow.activity !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "API Details"))
            : _createCommentVNode("", true),
          (_ctx.selectRow.activity !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.selectRow.details,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectRow.details) = $event)),
                  rows: "5",
                  cols: "150"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectRow.activity !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Activity"))
            : _createCommentVNode("", true),
          (_ctx.selectRow.activity !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.selectRow.activity,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectRow.activity) = $event)),
                  rows: "5",
                  cols: "150"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.selectRow.error && _ctx.selectRow.result !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Result"))
            : _createCommentVNode("", true),
          (!_ctx.selectRow.error && _ctx.selectRow.result !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.selectRow.result,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectRow.result) = $event)),
                  rows: "5",
                  cols: "150"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectRow.error && _ctx.selectRow.exception !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Exception"))
            : _createCommentVNode("", true),
          (_ctx.selectRow.error && _ctx.selectRow.exception !='null')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.selectRow.exception,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectRow.exception) = $event)),
                  rows: "5",
                  cols: "150"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.selectRow.request,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectRow.request) = $event)),
              rows: "8",
              cols: "150"
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}